import { CSS } from '@styles/stitches.config';

export const transitionColors: CSS = {
  transitionTimingFunction: 'ease',
  transitionDuration: '200ms',
  transitionProperty: 'background, color, border-color',
};
